import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/* eslint-disable @typescript-eslint/no-explicit-any */
import OktaAuth from '@okta/okta-auth-js';
import { buildConfigObject } from '@okta/configuration-validation';
import createHttpRequestClientMethod from './createHttpRequestClient';
var ACCESS_TOKEN_KEY = 'oktaAccessToken';
var ID_TOKEN_KEY = 'oktaIdToken';

var createAuthClient = function createAuthClient(config) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onTokenExpire = _ref.onTokenExpire,
      onTokenRenew = _ref.onTokenRenew;

  var oktaConfig = {
    issuer: config.issuer,
    clientId: config.clientId,
    redirectUri: config.redirectUri,
    businessArea: config.businessArea,
    pkce: true,
    tokenManager: {
      storage: config.tokenStorage || 'sessionStorage'
    },
    httpRequestClient: createHttpRequestClientMethod(config.clientId)
  };
  var oktaAuth = new OktaAuth(oktaConfig);

  if (onTokenExpire) {
    oktaAuth.tokenManager.on('expired', function (key, expiredToken) {
      onTokenExpire(expiredToken);
    });
  }

  if (onTokenRenew) {
    oktaAuth.tokenManager.on('renewed', function (key, newToken, oldToken) {
      onTokenRenew({
        oldToken: oldToken,
        newToken: newToken
      });
    });
  }

  function getAccessToken() {
    return _getAccessToken.apply(this, arguments);
  }

  function _getAccessToken() {
    _getAccessToken = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return oktaAuth.tokenManager.get(ACCESS_TOKEN_KEY);

            case 3:
              return _context.abrupt("return", _context.sent);

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error('getAccessToken error', _context.t0);
              return _context.abrupt("return", undefined);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _getAccessToken.apply(this, arguments);
  }

  function getIdToken() {
    return _getIdToken.apply(this, arguments);
  }

  function _getIdToken() {
    _getIdToken = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return oktaAuth.tokenManager.get(ID_TOKEN_KEY);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.error('getIdToken error', _context2.t0);
              return _context2.abrupt("return", undefined);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return _getIdToken.apply(this, arguments);
  }

  function hasSession() {
    return _hasSession.apply(this, arguments);
  } // We only want user to look authenticated when they have both accesstoken and idtoken
  // In examples from okta only one was need to flag the user as authenticated


  function _hasSession() {
    _hasSession = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var session;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return oktaAuth.session.exists();

            case 3:
              session = _context3.sent;
              return _context3.abrupt("return", session);

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", false);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return _hasSession.apply(this, arguments);
  }

  function isAuthenticated() {
    return _isAuthenticated.apply(this, arguments);
  }

  function _isAuthenticated() {
    _isAuthenticated = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getAccessToken();

            case 2:
              _context4.t0 = !!_context4.sent;

              if (!_context4.t0) {
                _context4.next = 7;
                break;
              }

              _context4.next = 6;
              return getIdToken();

            case 6:
              _context4.t0 = !!_context4.sent;

            case 7:
              return _context4.abrupt("return", _context4.t0);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _isAuthenticated.apply(this, arguments);
  }

  function isLoggedIn() {
    return _isLoggedIn.apply(this, arguments);
  }

  function _isLoggedIn() {
    _isLoggedIn = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var authenticated;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return isAuthenticated();

            case 2:
              authenticated = _context5.sent;
              _context5.next = 5;
              return authenticated ? isAuthenticated() : hasSession();

            case 5:
              return _context5.abrupt("return", _context5.sent);

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _isLoggedIn.apply(this, arguments);
  }

  function getUser() {
    return _getUser.apply(this, arguments);
  }

  function _getUser() {
    _getUser = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      var accessToken, idToken, userinfo;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return getAccessToken();

            case 2:
              accessToken = _context6.sent;
              _context6.next = 5;
              return getIdToken();

            case 5:
              idToken = _context6.sent;

              if (!(accessToken && idToken)) {
                _context6.next = 12;
                break;
              }

              _context6.next = 9;
              return oktaAuth.token.getUserInfo(accessToken, idToken);

            case 9:
              userinfo = _context6.sent;

              if (!(userinfo.sub === idToken.claims.sub)) {
                _context6.next = 12;
                break;
              }

              return _context6.abrupt("return", userinfo);

            case 12:
              return _context6.abrupt("return", idToken ? idToken.claims : undefined);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _getUser.apply(this, arguments);
  }

  function storeTokens(tokensObj) {
    oktaAuth.tokenManager.add(ACCESS_TOKEN_KEY, tokensObj.tokens.accessToken);
    oktaAuth.tokenManager.add(ID_TOKEN_KEY, tokensObj.tokens.idToken);
  }

  function getUrlParam(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp("[\\?&]".concat(name, "=([^&#]*)"));
    var results = regex.exec(url);
    return results === null ? undefined : results[1];
  } // gets tokens with a sessionToken or with an existing session


  function authenticate() {
    return _authenticate.apply(this, arguments);
  }

  function _authenticate() {
    _authenticate = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      var sessionToken,
          params,
          tokens,
          _args7 = arguments;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              sessionToken = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : undefined;
              params = buildConfigObject({});
              params.responseType = ['id_token', 'token'];
              params.scopes = ['openid', 'email', 'profile'];

              if (sessionToken !== undefined) {
                params.sessionToken = sessionToken;
              }

              _context7.next = 7;
              return oktaAuth.token.getWithoutPrompt(params);

            case 7:
              tokens = _context7.sent;
              storeTokens(tokens);
              return _context7.abrupt("return", tokens);

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _authenticate.apply(this, arguments);
  }

  function authenticateWithRedirect() {
    return _authenticateWithRedirect.apply(this, arguments);
  } // async function getTokensFromUrl(){
  //   // console.log('calling stuff', await oktaAuth.token.parseFromUrl());
  //   oktaAuth.token.parseFromUrl({redirectUri: 'https://localhost:8001/en-gb/portal/playground'})
  //     .then( (res:any) => {
  //       console.log('done parsing')
  //       console.log(res)
  //     })
  //     .catch( (err: any) =>{
  //       console.log(err)
  //     })
  // }


  function _authenticateWithRedirect() {
    _authenticateWithRedirect = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8() {
      var sessionToken,
          params,
          redirectUri,
          clientIdParam,
          _args8 = arguments;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              sessionToken = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : undefined;
              params = buildConfigObject({});
              params.responseType = ['code'];
              params.scopes = ['openid', 'email', 'profile'];

              if (sessionToken !== undefined) {
                params.sessionToken = sessionToken;
              }

              if (typeof window !== 'undefined') {
                redirectUri = getUrlParam('redirectUri') ? getUrlParam('redirectUri') : window.location.origin;
                clientIdParam = getUrlParam('clientId') !== undefined ? getUrlParam('clientId') : '';
                params.clientId = clientIdParam;
                params.redirectUri = redirectUri;
              }

              oktaAuth.token.getWithRedirect(params);
              return _context8.abrupt("return");

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _authenticateWithRedirect.apply(this, arguments);
  }

  function login(_x, _x2) {
    return _login.apply(this, arguments);
  }

  function _login() {
    _login = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee9(credentials, getWithRedirect) {
      var result;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return oktaAuth.signIn(credentials);

            case 2:
              result = _context9.sent;

              if (!(result.status === 'SUCCESS')) {
                _context9.next = 11;
                break;
              }

              if (!getWithRedirect) {
                _context9.next = 8;
                break;
              }

              _context9.next = 7;
              return authenticateWithRedirect(result.sessionToken);

            case 7:
              return _context9.abrupt("return", _context9.sent);

            case 8:
              _context9.next = 10;
              return authenticate(result.sessionToken);

            case 10:
              return _context9.abrupt("return", _context9.sent);

            case 11:
              return _context9.abrupt("return", undefined);

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    return _login.apply(this, arguments);
  }

  function logout() {
    return _logout.apply(this, arguments);
  }

  function _logout() {
    _logout = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              oktaAuth.tokenManager.clear();
              _context10.prev = 1;
              _context10.next = 4;
              return oktaAuth.revokeAccessToken();

            case 4:
              oktaAuth.closeSession();
              _context10.next = 10;
              break;

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](1);
              console.log('Error in logout:', _context10.t0);

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 7]]);
    }));
    return _logout.apply(this, arguments);
  }

  function getSession() {
    return _getSession.apply(this, arguments);
  }

  function _getSession() {
    _getSession = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return oktaAuth.session.get();

            case 3:
              return _context11.abrupt("return", _context11.sent);

            case 6:
              _context11.prev = 6;
              _context11.t0 = _context11["catch"](0);
              return _context11.abrupt("return", false);

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 6]]);
    }));
    return _getSession.apply(this, arguments);
  }

  function forgotPassword(_x3) {
    return _forgotPassword.apply(this, arguments);
  }

  function _forgotPassword() {
    _forgotPassword = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee12(email) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return oktaAuth.forgotPassword({
                username: email,
                factorType: 'EMAIL'
              });

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return _forgotPassword.apply(this, arguments);
  }

  function verifyRecoveryToken(_x4) {
    return _verifyRecoveryToken.apply(this, arguments);
  }

  function _verifyRecoveryToken() {
    _verifyRecoveryToken = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee13(token) {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return oktaAuth.verifyRecoveryToken({
                recoveryToken: token
              });

            case 2:
              return _context13.abrupt("return", _context13.sent);

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
    return _verifyRecoveryToken.apply(this, arguments);
  }

  return {
    isAuthenticated: isAuthenticated,
    isLoggedIn: isLoggedIn,
    getIdToken: getIdToken,
    getAccessToken: getAccessToken,
    getUser: getUser,
    login: login,
    logout: logout,
    hasSession: hasSession,
    getSession: getSession,
    authenticate: authenticate,
    forgotPassword: forgotPassword,
    verifyRecoveryToken: verifyRecoveryToken
  };
};

export default createAuthClient;